import aave from './icon-aave.png';
import ars from './icon-ars.png';
import axs from './icon-axs.png';
import bat from './icon-bat.png';
import bch from './icon-bch.png';
import brl from './icon-brl.png';
import btc from './icon-btc.png';
import busd from './icon-busd.png';
import ada from './icon-ada.png';
import algo from './icon-algo.png';
import chz from './icon-chz.png';
import comp from './icon-comp.png';
import cusd from './icon-cusd.png';
import dai from './icon-dai.png';
import doge from './icon-doge.png';
import dot from './icon-dot.png';
import eth from './icon-eth.png';
import glm from './icon-glm.png';
import husd from './icon-husd.png';
import link from './icon-link.png';
import ltc from './icon-ltc.png';
import luna from './icon-luna.png';
import mana from './icon-mana.png';
import matic from './icon-matic.png';
import mxn from './icon-mxn.png';
import pax from './icon-pax.png';
import placeHolder from './icon-placeHolder.png';
import qnt from './icon-qnt.png';
import sol from './icon-sol.png';
import tusd from './icon-tusd.png';
import uni from './icon-uni.png';
import usd from './icon-usd.png';
import usdc from './icon-usdc.png';
import usdt from './icon-usdt.png';
import xlm from './icon-xlm.png';
import xrp from './icon-xrp.png';
import yfi from './icon-yfi.png';
import cop from './icon-cop.png';
import usdp from './icon-usdp.png';

const assets = {
  aave,
  ada,
  algo,
  ars,
  axs,
  bat,
  bch,
  brl,
  btc,
  busd,
  chz,
  comp,
  cop,
  cusd,
  dai,
  doge,
  dot,
  eth,
  glm,
  husd,
  link,
  ltc,
  luna,
  mana,
  matic,
  mxn,
  pax,
  placeHolder,
  qnt,
  sol,
  tusd,
  uni,
  usd,
  usdc,
  usdp,
  usdt,
  xlm,
  xrp,
  yfi,
};

export default assets;
